/*
 * action types
 */
export const ERROR = 'ERROR'
export const SUCCESS = 'SUCCESS'

/*
 * action creators
 */

export function error(payload) {
  return {
    payload,
    type: ERROR,
  }
}
export function success(payload) {
  return {
    payload,
    type: SUCCESS,
  }
}
